export function APIException(code, message="An error occurred"){
    const error = new Error(message)
    error.code = code
    return error;
}

APIException.prototype = Object.create(Error.prototype);